import { formModel, SuggestedResource, SuggestedResourceFormModel } from '../../../../../_models/taxonomy/suggested-resource';

export function EditButton(props: { resource: SuggestedResource; showModal: (resource: SuggestedResourceFormModel) => void; }) {
    return <button type="button" className='btn btn-sm btn-icon-only btn-primary rounded-circle' data-pr-tooltip="Edit Topic"
        onClick={() => props.showModal(formModel(props.resource, true))}
    ><i className="fas fa-pen"></i></button>;
}
